import { type FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '..';

import { ScCopyCode } from './styled';

export type TCopyCodeButtonColor =
  | 'orange'
  | 'goldGradient'
  | 'goldenOrangeGradient';

export type TBorderStyleButton = 'dotted' | 'dashed';

interface CopyCodeProps {
  code: string;
  copyActive: boolean;
  setCopyActive: (copyActive: boolean) => void;
  hoverColor?: string;
  noMarginBottom?: boolean;
  buttonColor?: TCopyCodeButtonColor;
  borderStyle?: TBorderStyleButton;
}

export const DashedCopyCode: FC<CopyCodeProps> = ({
  code,
  copyActive,
  setCopyActive,
  hoverColor,
  noMarginBottom,
  buttonColor = 'orange',
  borderStyle = 'dotted',
}) => {
  const { t } = useTranslation('common');

  const handleCopyCode = useCallback(() => {
    navigator.clipboard.writeText(code);
    setCopyActive(true);
  }, [code, setCopyActive]);

  const handleAnimationEnd = () => {
    setCopyActive(false);
  };

  const buttonColorConfig = {
    orange: {
      orange: true,
    },
    goldGradient: {
      goldGradient: true,
    },
    goldenOrangeGradient: {
      goldenOrangeGradient: true,
    },
  };

  return (
    <>
      {code && (
        <ScCopyCode
          borderStyle={borderStyle}
          copyActive={copyActive}
          hoverColor={hoverColor}
          noMarginBottom={noMarginBottom}
        >
          <div
            className="copy-code"
            data-access={t('copyCode.access')}
            onAnimationEnd={handleAnimationEnd}
          >
            <p className="notranslate" translate="no">
              {code}
            </p>
          </div>
          <Button
            primary
            {...buttonColorConfig[buttonColor]}
            onClick={handleCopyCode}
          >
            {t('copyCode.copyText')}
          </Button>
        </ScCopyCode>
      )}
    </>
  );
};
